import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RouterService } from '@modules/business-accounts/core/router/router.service';
import { AssetLink } from '@utils/helpers/asset-cpm-link';

@Component({
  selector: 'ba-view-natural-person-account-limit',
  templateUrl: './view-natural-person-account-limit.component.html',
  styleUrls: ['./view-natural-person-account-limit.component.scss']
})
export class ViewNaturalPersonAccountLimitComponent extends AssetLink() implements OnInit {

  @Output() onShowViewConfiguration = new EventEmitter<boolean>();

  isLoading = false;

  constructor(public readonly viewRouter: RouterService) {
    super();
  }

  ngOnInit(): void {
  }

  stepConfiguration() {
    this.onShowViewConfiguration.emit(false);
  }
}